import { useTranslation } from 'react-i18next';

import { OrgMemberPicker } from '@/features/org/components/org-member-picker/org-member-picker';
import { useAcceptSubprojectInvitationStore } from '@/features/partners/store/use-accept-subproject-invitation-store';
import { useOrgMembersForProject } from '@/features/projects/create-project/hooks/use-org-members-for-project';
import {
  FlowBackButton,
  FlowSubmitButton,
} from '@/shared/components/flow/flow-actions';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card';

export const AcceptInvitationInviteMembersInputPage = () => {
  const { data, setData } = useAcceptSubprojectInvitationStore();

  const handleNext = (memberId: string) => {
    setData({
      invitedMembers: [
        ...(data.invitedMembers || []),
        orgMembers?.find((member) => member.member_id === memberId)!,
      ].filter((member) => member !== undefined),
      step: 'inviteMembersOverview',
    });
  };

  const handleBack = () => {
    setData({ step: 'inviteMembersOverview' });
  };

  const { t } = useTranslation('subproject', {
    keyPrefix: 'AcceptInvitation.InviteMembersInputForm',
  });

  const { data: orgMembers } = useOrgMembersForProject();

  return (
    <Card variant="form" wrapWithStars>
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <OrgMemberPicker
          orgMembers={orgMembers}
          existingInvitations={
            data.invitedMembers?.map((member) => member.member_id) || []
          }
          onSuccess={handleNext}
        />
      </CardContent>
      <CardFooter>
        <FlowBackButton onClick={handleBack}>
          {t('back_button_label')}
        </FlowBackButton>
        <FlowSubmitButton>{t('submit_button_label')}</FlowSubmitButton>
      </CardFooter>
    </Card>
  );
};
